module.exports = __webpack_public_path__ + "static/img/introduce_7.935c1af.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/hlw/popup/introduce_7.png
// module id = zmsf
// module chunks = 1